module.exports = __webpack_public_path__ + "img/A高通锐化10.5c055deb.png";